import { HttpContextToken, HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { throwError, timeout } from 'rxjs';

const DEFAULT_TIMEOUT_MS = 120_000;

/**
 * Per-request override таймаута. Использовать для тяжёлых запросов
 * (выгрузка xlsx и т.п.):
 *
 *   http.post(url, body, { context: new HttpContext().set(HTTP_TIMEOUT_MS, 120_000) })
 *
 * Если контекст не задан — применяется DEFAULT_TIMEOUT_MS.
 */
export const HTTP_TIMEOUT_MS = new HttpContextToken<number>(() => DEFAULT_TIMEOUT_MS);

export const timeoutInterceptor: HttpInterceptorFn = (req, next) => {
  const ms = req.context.get(HTTP_TIMEOUT_MS);
  return next(req).pipe(
    timeout({
      each: ms,
      with: () =>
        throwError(
          () =>
            new HttpErrorResponse({
              status: 504,
              statusText: 'Network timeout',
              url: req.url,
            }),
        ),
    }),
  );
};
